import { render, staticRenderFns } from "./TagGroupLandingPage.vue?vue&type=template&id=0cfd7d38&scoped=true&lang=html&"
import script from "./TagGroupLandingPage.vue?vue&type=script&lang=js&"
export * from "./TagGroupLandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfd7d38",
  null
  
)

export default component.exports